import type { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FormSkeleton } from "@/shared/components/FormSkeleton";

export const ErrorFallback: FC = () => {
    const { ready, i18n } = useTranslation();

    if (!ready) return <FormSkeleton />;

    return (
        <div className="alert" role="alert">
            <Trans
                i18n={i18n}
                i18nKey="error.technicalDifficulties"
                components={{
                    refresh: <button type="button" className="link" onClick={() => window.location.reload()} />,
                }}
            />
        </div>
    );
};
